import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

const PrintRecord = () => {
  const componentToPrintRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });

  const [ticketCode, setTicketCode] = useState('1');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    let { name, cellphone, reservationNumber } = data;
    reservationNumber = parseInt(ticketCode + reservationNumber);
    //axios로 가져오고 성공하면 바로 프린트, 실패하면 재입력 유도
    handlePrint();
  };
  return (
    <Container>
      <h1 className="mt-3 mb-5">기록증 출력</h1>
      <p>
        2021년에 시행된 언텍트 마라톤 종목에 대한 기록증을 출력할 수 있습니다.
      </p>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="formName" className="mt-3 mb-5">
            <Form.Label>이름</Form.Label>
            <input
              type="text"
              className="form-in-class"
              placeholder="홍길동"
              {...register('name', {
                required: true,
                maxLength: 50,
                pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
              })}
            />
            {errors.name && (
              <span
                className="position-absolute"
                style={{ fontSize: '0.8rem', color: 'red' }}
              >
                (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
              </span>
            )}
          </Form.Group>
          <Form.Group controlId="formPhoneNumber" className="mt-3 mb-5">
            <Form.Label>전화번호</Form.Label>
            <input
              type="number"
              className="form-in-class"
              placeholder="01012345678"
              {...register('cellphone', {
                required: true,
                maxLength: 11,
                pattern: /^[0-9]{4,11}/g,
              })}
            />
            {errors.cellphone && (
              <span
                className="position-absolute"
                style={{ fontSize: '0.8rem', color: 'red' }}
              >
                (필수)전화번호는 4자 이상, 11자 이하의 숫자만 입력해주세요.
              </span>
            )}
          </Form.Group>
          <Form.Group controlId="formReserveNumber" className="mt-3 mb-5">
            <Form.Label>접수번호</Form.Label>
            {/* <Form.Control
            type="text"
            placeholder="23"
            value={reservationNumber}
            onChange={onChangeReservationNumber}
          /> */}
            <Row>
              <Col xs={{ span: 3 }}>
                <select onChange={(e) => setTicketCode(e.target.value)}>
                  <option value="1">1(오프라인M)</option>
                  <option value="3">3(언텍트M)</option>
                  <option value="5">5(언텍트 트레킹)</option>
                </select>
              </Col>
              <Col xs={{ span: 1 }}>
                <span
                  style={{
                    lineHeight: '2rem',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                  }}
                >
                  −
                </span>
              </Col>
              <Col>
                <input
                  type="number"
                  placeholder="0098"
                  className="form-in-class"
                  {...register('reservationNumber', {
                    required: true,
                    maxLength: 4,
                    pattern: /^[0-9]{4,4}/g,
                  })}
                />
                {errors.reservationNumber && (
                  <span
                    className="position-absolute"
                    style={{ fontSize: '0.8rem', color: 'red' }}
                  >
                    (필수)접수번호는 4자리 숫자로 입력해주세요
                  </span>
                )}
              </Col>
            </Row>
          </Form.Group>
          <input
            type="submit"
            className="bg-custom-color p-2 rounded text-white mb-5"
            style={{ border: 'none' }}
            value="기록증 출력하기"
          />
        </form>
      </div>
      <ComponentToPrint ref={componentToPrintRef} />
    </Container>
  );
};
export default PrintRecord;

class ComponentToPrint extends React.Component {
  render() {
    return (
      <div
        className="backno"
        style={{
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: 'url(/마라톤기록증.png)',
          backgroundRepeat: 'no-repeat',
          fontSize: '1.5rem',
          fontWeight: 'bold',
        }}
      >
        <p style={{ paddingTop: '27.6rem', paddingLeft: '20rem' }}>홍길동</p>
        <p style={{ paddingTop: '2.6rem', paddingLeft: '21rem' }}>3분 14초</p>
        <p style={{ paddingTop: '2.5rem', paddingLeft: '21rem' }}>
          언텍트M (10km)
        </p>
        <p style={{ paddingTop: '2.4rem', paddingLeft: '26rem' }}>10231</p>
        <p style={{ paddingTop: '8rem' }} className="text-center">
          2021년 10월 17일
        </p>
      </div>
    );
  }
}
